/**
 * The shared user picker, scoped by the sidebar's tenant filter.
 *
 * The picker lives in shared-ui and knows nothing about this console's
 * sidebar; this is the one place the two meet, so every admin page that
 * searches for a person narrows to the selected tenant the same way the
 * Users page does — and "All tenants" searches everything the caller may see.
 */
import { UserSearchFilter, type UserSearchFilterProps } from '@shared-ui/user-picker';
import { ALL_TENANTS, useSelectedTenantId } from './TenantFilter';

export function ScopedUserSearchFilter(props: Omit<UserSearchFilterProps, 'tenantId'>) {
    const selected = useSelectedTenantId();
    return <UserSearchFilter {...props} tenantId={selected === ALL_TENANTS ? undefined : selected} />;
}
